import Container from './DeviationSubmitNotification.container';
import DeviationSubmitNotification from './DeviationSubmitNotification';

export default Container(DeviationSubmitNotification);
